import {
  Box,
  TextField,
  Button,
  Card,
  CardContent,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
} from "@mui/material";
import { useState } from "react";

import { toast } from "react-toastify";
import axios from "axios";
import UserDetailsTable from "./UserDetailsTable";
import Swal from "sweetalert2";
import axiosInstance from "../../utils/axiosInstance";
import LoginQR from "../../components/LoginQR";
import Mfa from "../../components/Mfa";
import { use } from "react";
import MMTCUserDetailsTable from "./mmtcUserDetailTable";

const Modal = ({ open, onClose, children }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* backdrop */}
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      {/* modal content */}
      <div className="relative z-10 w-full max-w-xl bg-white rounded-xl shadow-xl">
        {children}
      </div>
    </div>
  );
};

const UpdateKyc = ({ type }) => {
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");
  const [formData, setFormData] = useState({
    uniqueId: "",
    dob: "",
    customerRefNo: "", // added for MMTC
  });
  const [formData1, setFormData1] = useState({
    uniqueId1: "",
    customerRefNo: "", // added for MMTC
  });
  // console.log("formData1", formData1);
  const [userData, setUserData] = useState(null);
  // console.log("userData", userData);
  const [openModal, setOpenModal] = useState(false);
  const [responseData, setResponseData] = useState(null);
  // const [flag, setFlag] = useState(false)
  const [otpAction, setOtpAction] = useState(null);
  // values: "update" | "getDetails"

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFormData1((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [loading, setLoading] = useState(false);
  const updateKycApi = async (props) => {
    try {
      // console.log(")))))))))))))))))", props)
      // console.log(")))))))))))))))))", props.uniqueId)
      // console.log(")))))))))))))))))", props.formattedDob)
      // console.log(")))))))))))))))))", props.customerRefNo)
      if (type === "augmont") {
        const url = `/updateKyc/${props.uniqueId}`;
        const mfaToken = otp.join("");
        // console.log("ammmmmmmmmm", props)
        setLoading(true);

        const response = await axiosInstance.post(url, {
          dob: props.formattedDob,
          mfa_token: mfaToken,
        });
        // const response = await axios.post(url, { dob }, { headers });
        // const response = await axios.post(url, { dob, mfa_token: mfaToken }, { headers });
        // console.log("response", response.data.result);
        if (response.data.error === false) {
          setOtp(["", "", "", "", "", ""]);
          setOpenOtpModal(false);
          Swal.fire({
            text: response.data.message,
            icon: "success",
            timer: 3000,
            showConfirmButton: false,
          });
          setOpenModal(true);
          setResponseData(response.data.data.result.data);
          setFormData({
            uniqueId: "",
            dob: "",
          });
        } else {
          // Swal.fire({
          //   text: response.data.message,
          //   icon: "error",
          //   timer: 3000,
          //   showConfirmButton: false,
          // });
          setOtp(["", "", "", "", "", ""]);
          setOpenOtpModal(false);

          Swal.fire({
            text: response.data.message,
            icon: "error",
            timer: 3000,
            showConfirmButton: false,
            didOpen: () => {
              const swalContainer = document.querySelector(".swal2-container");
              if (swalContainer) {
                swalContainer.style.zIndex = "2000"; // 2000 > MUI Dialog z-index
              }
            },
          });
        }
      } else if (type === "mmtc") {
        const url = `/mmtc/update/profile`;
        const mfaToken = otp.join("");
        const customerRefNO = props.customerRefNo;
        setLoading(true);
        const response = await axiosInstance.post(url, {
          customerRefNo: customerRefNO,
          mfa_token: mfaToken,
        });
        // const response = await axios.post(url, { dob }, { headers });
        // const response = await axios.post(url, { dob, mfa_token: mfaToken }, { headers });
        // console.log("response", response.data.result);

        if (response.data.error === false) {
          setOtp(["", "", "", "", "", ""]);
          setOpenOtpModal(false);
          Swal.fire({
            text: response.data.message,
            icon: "success",
            timer: 3000,
            showConfirmButton: false,
          });
          setOpenModal(true);
          setResponseData(response.data.data);
          // console.log("************original res**************", response);
          // console.log("**************************", response.data.data);
          setFormData({
            uniqueId: "",
            dob: "",
            customerRefNo: "",
          });
        } else {
          // Swal.fire({
          //   text: response.data.message,
          //   icon: "error",
          //   timer: 3000,
          //   showConfirmButton: false,
          // });
          setOtp(["", "", "", "", "", ""]);
          setOpenOtpModal(false);
          Swal.fire({
            text: response.data.message,
            icon: "error",
            timer: 3000,
            showConfirmButton: false,
            didOpen: () => {
              const swalContainer = document.querySelector(".swal2-container");
              if (swalContainer) {
                swalContainer.style.zIndex = "2000"; // 2000 > MUI Dialog z-index
              }
            },
          });
        }
      }
    } catch (error) {
      // toast.error(error.response.data.message);
      Swal.fire({
        text: error.response.data.message,
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };
  const getUpdateData = async (props) => {
    try {
      // console.log("aman++++piyush sir---------------", props.uniqueId)
      // console.log("aman++++piyush sir---------------", props.customerRefNo)

      if (type === "augmont") {
        const url = `/getUserPanBank/${props.uniqueId}`;
        // const urlMMTC=``
        // const url = `${baseUrl}/getUserPanBank/${uniqueId}`;
        const headers = {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        };
        const response = await axiosInstance.get(url);
        // const response = await axios.get(url, { headers });
        setUserData(response.data.data);
        if (response.data.error === false) {
          //  Swal.fire({
          //         text: response.data.message,
          //         // text: "Please fill in both fields",
          //         icon: "error",
          //         timer: 3000,
          //         showConfirmButton: false,
          //       });
          // toast.success(response.data.message);
        } else {
          Swal.fire({
            text: response.data.message,
            // text: "Please fill in both fields",
            icon: "error",
            timer: 3000,
            showConfirmButton: false,
          });
          // toast.error(response.data.message);
        }
      } else if (type === "mmtc") {
        // console.log("piyush_________sir", props)
        // console.log("piyush_________sir", props.customerRefNo)
        // console.log("piyush_________sir", props.mfa_token)

        const customerRefNO = props.customerRefNo;

        // console.log("---------------------", customerRefNO)
        const MFAtoken = props.mfa_token;
        const url = `/mmtc/getProfileDetails`;
        // const urlMMTC=``
        // const url = `${baseUrl}/getUserPanBank/${uniqueId}`;
        const headers = {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        };
        const response = await axiosInstance.post(url, {
          customerRefNo: customerRefNO,
          mfa_token: MFAtoken,
        });
        // const response = await axios.get(url, { headers });
        setUserData(response.data.data);
        // console.log(";;;;;;;;;;;;;;;;;;;;;", response.data);
        if (response.data.error === false) {
          //  Swal.fire({
          //         text: response.data.message,
          //         // text: "Please fill in both fields",
          //         icon: "error",
          //         timer: 3000,
          //         showConfirmButton: false,
          //       });
          // toast.success(response.data.message);
          setOtp(["", "", "", "", "", ""]);
          setOpenOtpModal(false);
        } else {
          Swal.fire({
            text: response.data.message,
            // text: "Please fill in both fields",
            icon: "error",
            timer: 3000,
            showConfirmButton: false,
          });
          // toast.error(response.data.message);
        }
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const handleOneSubmit = async () => {
    if (type === "augmont") {
      if (!formData1.uniqueId1) {
        Swal.fire({
          // text: response.data.message,
          text: "Please fill in the Unique ID field",
          icon: "error",
          timer: 3000,
          showConfirmButton: false,
        });
        return;
      }

      await getUpdateData({ uniqueId: formData1.uniqueId1 });
    } else if (type === "mmtc") {
      if (!formData1.customerRefNo) {
        Swal.fire({
          // text: response.data.message,
          text: "Please fill the customerRefNo",
          icon: "error",
          timer: 3000,
          showConfirmButton: false,
        });
        return;
      }
      // setFlag(true)
      // setOtpAction("getDetails");
      // setOpenOtpModal(true)
      await getUpdateData({ customerRefNo: formData1.customerRefNo });
      // handleSubmit()

      // handleSubmit("secondCard")
    }

    // await getUpdateData(formData1.uniqueId1);

    // Add API call here
    // console.log("Form submitted:", formData);
    // toast.success("KYC submitted successfully!");
  };

  const formatDate = (inputDate) => {
    const [year, month, day] = inputDate.split("-");
    return `${day}-${month}-${year}`;
  };

  const handleValidate = () => {
    if (type === "augmont") {
      if (!formData.uniqueId || !formData.dob) {
        Swal.fire({
          text: "Please fill in both fields",
          icon: "error",
          timer: 3000,
          showConfirmButton: false,
        });
        return;
      }
    } else if (type === "mmtc") {
      if (!formData.customerRefNo) {
        // console.log(";;;;;;;;===============", formData.customerRefNo);

        // Swal.fire({
        //   text: "Please fill the customerRefNo",
        //   icon: "error",
        //   timer: 3000,
        //   showConfirmButton: false,
        // });

        Swal.fire({
          text: "Please fill the customerRefNo",
          icon: "error",
          timer: 3000,
          showConfirmButton: false,
          didOpen: () => {
            const swalContainer = document.querySelector(".swal2-container");
            if (swalContainer) {
              swalContainer.style.zIndex = "2000"; // 2000 > MUI Dialog z-index
            }
          },
        });

        return;
      }
    }

    setOtpAction("update");
    setOpenOtpModal(true);
  };

  const [mmtcLoading, setMmtcLoading] = useState(true);

  const handleSubmit = async () => {
    if (type === "augmont") {
      const formattedDob = formatDate(formData.dob);
      await updateKycApi({ uniqueId: formData.uniqueId, formattedDob });
    } else if (type === "mmtc") {
      // if (otpAction === "getDetails") {
      //   const mfaToken = otp.join("");
      //   await getUpdateData({ customerRefNo: formData1.customerRefNo, mfa_token: mfaToken });
      // }
      // if (otpAction === "update") {

      await updateKycApi({ customerRefNo: formData.customerRefNo });

      // }
    }
    // console.log("Form submitted:", formData);
    // toast.success("KYC submitted successfully!");
  };

  // const [showOtp, setShowOtp] = useState(false);
  const [openOtpModal, setOpenOtpModal] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);

  //-----------tabs vala return-------------------------

  // return (
  //   <>
  //     {!openOtpModal ? (
  //       <>
  //         <Box
  //           sx={{
  //             boxShadow: 3,
  //             borderRadius: 2,
  //             p: 3,
  //             mb: 3,
  //             backgroundColor: "#fff",
  //             overflow: "visible",
  //           }}
  //         >
  //           {/* ---------- HEADINGS ---------- */}
  //           <Box sx={{ mb: 3 }}>
  //             {type === "augmont" && (
  //               <>
  //                 <Typography variant="h6" fontWeight="bold">
  //                   Augmont KYC
  //                 </Typography>

  //               </>
  //             )}

  //             {type === "mmtc" && (
  //               <>
  //                 <Typography variant="h6" fontWeight="bold">
  //                   MMTC KYC
  //                 </Typography>

  //               </>
  //             )}
  //           </Box>
  //           <Card sx={{ margin: "auto", p: { xs: 0 }, mb: 3, overflow: "visible" }}>
  //             {/* <ToastComponent /> */}
  //             <CardContent>
  //               <Grid container spacing={2} alignItems="center">
  //                 <Grid item xs={12} sm={5}>
  //                  {type==="augmont"?(
  //                  <TextField
  //                     label="Unique ID"
  //                     name="uniqueId"
  //                     size="small"
  //                     variant="outlined"
  //                     value={formData.uniqueId}
  //                     onChange={handleChange}
  //                     fullWidth
  //                     autoComplete="off"
  //                   />):(<TextField
  //                     label="customerRefNo"
  //                     name="customerRefNo"
  //                     size="small"
  //                     variant="outlined"
  //                     value={formData.customerRefNo}
  //                     onChange={handleChange}
  //                     fullWidth
  //                     autoComplete="off"
  //                   />)}
  //                 </Grid>

  //                 {type==="augmont" && (
  //                 <Grid item xs={12} sm={5}>
  //                   <TextField
  //                     label="DOB"
  //                     name="dob"
  //                     type="date"
  //                     size="small"
  //                     variant="outlined"
  //                     value={formData.dob}
  //                     onChange={handleChange}
  //                     fullWidth
  //                     autoComplete="off"
  //                     InputLabelProps={{ shrink: true }}
  //                   />
  //                 </Grid>
  //                 )}

  //                 <Grid item xs={12} sm={2}>
  //                   <Button
  //                     variant="contained"
  //                     color="primary"
  //                     size="medium"
  //                     fullWidth
  //                     onClick={handleValidate}
  //                   // onClick={handleSubmit}
  //                   >
  //                     Send
  //                   </Button>
  //                 </Grid>
  //               </Grid>
  //             </CardContent>

  //             {/* Success Modal */}
  //             <Dialog
  //               open={openModal}
  //               onClose={() => setOpenModal(false)}
  //               fullWidth
  //               maxWidth="sm"
  //             >
  //               <DialogTitle>KYC Details</DialogTitle>
  //               <DialogContent dividers>
  //                 {responseData && (
  //                   <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
  //                     <Typography>
  //                       <strong>Unique ID:</strong> {responseData.uniqueId}
  //                     </Typography>
  //                     <Typography>
  //                       <strong>Name:</strong> {responseData.name}
  //                     </Typography>
  //                     <Typography>
  //                       <strong>Date of Birth:</strong>{" "}
  //                       {formatDate(responseData.dateOfBirth)}
  //                     </Typography>
  //                     <Typography>
  //                       <strong>PAN Number:</strong> {responseData.panNumber || "N/A"}
  //                     </Typography>
  //                     <Typography>
  //                       <strong>Status:</strong> {responseData.status}
  //                     </Typography>
  //                   </Box>
  //                 )}
  //               </DialogContent>
  //               <DialogActions>
  //                 <Button onClick={() => setOpenModal(false)}>Close</Button>
  //               </DialogActions>
  //             </Dialog>
  //           </Card>
  //           <Card sx={{ margin: "auto", p: { xs: 0 }, mb: 3, overflow: "visible" }}>
  //             {/* <ToastComponent /> */}
  //             <CardContent>
  //               <Typography component="body2">Users Details</Typography>
  //               <Grid container spacing={2} alignItems="center">
  //                 <Grid item xs={12} sm={5}>

  //                   {type==="augmont"?(
  //                     <TextField
  //                     label="Unique ID"
  //                     name="uniqueId1"
  //                     size="small"
  //                     variant="outlined"
  //                     value={formData1.uniqueId1}
  //                     onChange={handleChange1}
  //                     fullWidth
  //                     autoComplete="off"
  //                   />):(<TextField
  //                     label="customerRefNo"
  //                     name="customerRefNo"
  //                     size="small"
  //                     variant="outlined"
  //                     value={formData1.customerRefNo}
  //                     onChange={handleChange1}
  //                     fullWidth
  //                     autoComplete="off"
  //                   />)}

  //                 </Grid>

  //                 <Grid item xs={12} sm={2}>
  //                   <Button
  //                     variant="contained"
  //                     color="primary"
  //                     size="medium"
  //                     fullWidth
  //                     onClick={handleOneSubmit}
  //                   >
  //                     submit
  //                   </Button>
  //                 </Grid>
  //               </Grid>
  //             </CardContent>
  //           </Card>
  //         </Box>
  //         {userData && <Box sx={{
  //           boxShadow: 3,
  //           borderRadius: 2,
  //           p: 3,
  //           mb: 3,
  //           backgroundColor: "#fff",
  //           overflow: "visible",
  //         }}><UserDetailsTable data={userData} /></Box>}
  //       </>
  //     ) : (
  //       <div className="dishant">
  //         <Mfa setOtp={setOtp} otp={otp} handleSubmintOTP={handleSubmit} showOtp={openOtpModal} loading={loading} setOpenOtpModal={setOpenOtpModal} />
  //       </div>
  //     )}
  //     {/* <Modal open={openOtpModal} onClose={() => setOpenOtpModal(false)}> */}
  //     {/* </Modal> */}
  //   </>
  // );

  //--------------closing tab vala return----------

  //-----------fix vala-------------------------

  return (
    <>
      <>
        <Box
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            p: 3,
            mb: 3,
            mt: 4,
            backgroundColor: "#fff",
            overflow: "visible",
          }}
        >
          {/* ---------- HEADINGS ---------- */}
          <Box sx={{ mb: 3 }}>
            {type === "augmont" && (
              <>
                <Typography variant="h6" fontWeight="bold">
                  Augmont KYC
                </Typography>
              </>
            )}

            {type === "mmtc" && (
              <>
                <Typography variant="h6" fontWeight="bold">
                  MMTC KYC
                </Typography>
              </>
            )}
          </Box>
          <Card
            sx={{ margin: "auto", p: { xs: 0 }, mb: 3, overflow: "visible" }}
          >
            {/* <ToastComponent /> */}
            <CardContent>
              <Grid container spacing={2} alignItems="center">
                {type === "augmont" ? (
                  <Grid item xs={12} sm={5}>
                    <TextField
                      label="Unique ID"
                      name="uniqueId"
                      size="small"
                      variant="outlined"
                      value={formData.uniqueId}
                      onChange={handleChange}
                      fullWidth
                      autoComplete="off"
                    />
                  </Grid>
                ) : (
                  <Grid item xs={9} sm={8}>
                    <TextField
                      label="customerRefNo"
                      name="customerRefNo"
                      size="small"
                      variant="outlined"
                      value={formData.customerRefNo}
                      onChange={handleChange}
                      fullWidth
                      autoComplete="off"
                    />
                  </Grid>
                )}

                {type === "augmont" && (
                  <Grid item xs={12} sm={5}>
                    <TextField
                      label="DOB"
                      name="dob"
                      type="date"
                      size="small"
                      variant="outlined"
                      value={formData.dob}
                      onChange={handleChange}
                      fullWidth
                      autoComplete="off"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                )}

                <Grid item xs={12} sm={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    fullWidth
                    onClick={handleValidate}
                    // onClick={handleSubmit}
                  >
                    Send
                  </Button>
                </Grid>
              </Grid>
            </CardContent>

            {/* Success Modal */}
            {type === "augmont" ? (
              <Dialog
                open={openModal}
                onClose={() => setOpenModal(false)}
                fullWidth
                maxWidth="sm"
              >
                <DialogTitle>KYC Details</DialogTitle>
                <DialogContent dividers>
                  {responseData && (
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                    >
                      <Typography>
                        <strong>Unique ID:</strong> {responseData.uniqueId}
                      </Typography>
                      <Typography>
                        <strong>Name:</strong> {responseData.name}
                      </Typography>
                      <Typography>
                        <strong>Date of Birth:</strong>{" "}
                        {formatDate(responseData.dateOfBirth)}
                      </Typography>
                      <Typography>
                        <strong>PAN Number:</strong>{" "}
                        {responseData.panNumber || "N/A"}
                      </Typography>
                      <Typography>
                        <strong>Status:</strong> {responseData.status}
                      </Typography>
                    </Box>
                  )}
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenModal(false)}>Close</Button>
                </DialogActions>
              </Dialog>
            ) : (
              <Dialog
                open={openModal}
                onClose={() => setOpenModal(false)}
                fullWidth
                maxWidth="sm"
              >
                <DialogTitle>MMTC Customer Details</DialogTitle>

                <DialogContent dividers>
                  {responseData && (
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                    >
                      <Typography>
                        <strong>Full Name:</strong> {responseData.fullName}
                      </Typography>

                      <Typography>
                        <strong>Mobile:</strong> {responseData.mobileNumber}
                      </Typography>

                      <Typography>
                        <strong>Email:</strong> {responseData.emailAddress}
                      </Typography>

                      <Typography>
                        <strong>DOB:</strong>{" "}
                        {new Date(responseData.dob).toLocaleDateString()}
                      </Typography>

                      <Typography>
                        <strong>Customer Ref No:</strong>{" "}
                        {responseData.customerRefNo}
                      </Typography>

                      <Typography>
                        <strong>DG Customer Ref No:</strong>{" "}
                        {responseData.dgCustomerRefNo}
                      </Typography>

                      <Typography>
                        <strong>KYC Status:</strong>{" "}
                        {responseData.kycStatus === "Y"
                          ? "Verified"
                          : "Pending"}
                      </Typography>

                      <Typography>
                        <strong>Name Proof Type:</strong>{" "}
                        {responseData.kycInfo?.nameProofType || "N/A"}
                      </Typography>

                      <Typography>
                        <strong>Name Proof Doc No:</strong>{" "}
                        {responseData.kycInfo?.nameProofDocNo || "N/A"}
                      </Typography>

                      <Typography>
                        <strong>Update Result:</strong>{" "}
                        {responseData.updateResult}
                      </Typography>
                    </Box>
                  )}
                </DialogContent>

                <DialogActions>
                  <Button onClick={() => setOpenModal(false)}>Close</Button>
                </DialogActions>
              </Dialog>
            )}
          </Card>
          <Card
            sx={{ margin: "auto", p: { xs: 0 }, mb: 3, overflow: "visible" }}
          >
            {/* <ToastComponent /> */}
            <CardContent>
              <Typography component="body2">Users Details</Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={9} sm={8}>
                  {type === "augmont" ? (
                    <TextField
                      label="Unique ID"
                      name="uniqueId1"
                      size="small"
                      variant="outlined"
                      value={formData1.uniqueId1}
                      onChange={handleChange1}
                      fullWidth
                      autoComplete="off"
                    />
                  ) : (
                    <TextField
                      label="customerRefNo"
                      name="customerRefNo"
                      size="small"
                      variant="outlined"
                      value={formData1.customerRefNo}
                      onChange={handleChange1}
                      fullWidth
                      autoComplete="off"
                    />
                  )}
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    fullWidth
                    onClick={handleOneSubmit}
                  >
                    submit
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
        {userData && (
          <Box
            sx={{
              boxShadow: 3,
              borderRadius: 2,
              p: 3,
              mb: 3,
              backgroundColor: "#fff",
              overflow: "visible",
            }}
          >
            {type == "augmont" ? (
              <UserDetailsTable data={userData} />
            ) : (
              <MMTCUserDetailsTable data={userData} />
            )}
          </Box>
        )}
      </>
      {openOtpModal && (
        <Dialog
          open={openOtpModal}
          onClose={() => setOpenOtpModal(false)}
          fullWidth
          maxWidth="xs"
        >
          <div className="dishant">
            <Mfa
              setOtp={setOtp}
              otp={otp}
              handleSubmintOTP={handleSubmit}
              showOtp={openOtpModal}
              loading={loading}
              setOpenOtpModal={setOpenOtpModal}
            />
          </div>
        </Dialog>
      )}
      {/* <Modal open={openOtpModal} onClose={() => setOpenOtpModal(false)}> */}
      {/* </Modal> */}
    </>
  );

  //--------------closing fix vala return----------

  //------------------without tab vala return--------------------------

  //   return (
  //   <>
  //     {!openOtpModal ? (
  //       <Box sx={{ p: 3 }}>
  //         <Grid container spacing={3}>

  //           {/* -------- LEFT SIDE : AUGMONT -------- */}
  //           <Grid item xs={12} md={6}>
  //             <Box
  //               sx={{
  //                 boxShadow: 3,
  //                 borderRadius: 2,
  //                 p: 3,
  //                 backgroundColor: "#fff",
  //                 height: "100%",
  //               }}
  //             >
  //               <Typography variant="h6" fontWeight="bold" mb={2}>
  //                 Augmont KYC
  //               </Typography>

  //               {/* First Card */}
  //               <Card sx={{ mb: 3 }}>
  //                 <CardContent>
  //                   <Grid container spacing={2}>
  //                     <Grid item xs={12} sm={6}>
  //                       <TextField
  //                         label="Unique ID"
  //                         name="uniqueId"
  //                         size="small"
  //                         value={formData.uniqueId}
  //                         onChange={handleChange}
  //                         fullWidth
  //                       />
  //                     </Grid>

  //                     <Grid item xs={12} sm={6}>
  //                       <TextField
  //                         label="DOB"
  //                         name="dob"
  //                         type="date"
  //                         size="small"
  //                         value={formData.dob}
  //                         onChange={handleChange}
  //                         fullWidth
  //                         InputLabelProps={{ shrink: true }}
  //                       />
  //                     </Grid>

  //                     <Grid item xs={12}>
  //                       <Button
  //                         variant="contained"
  //                         fullWidth
  //                         onClick={handleValidate}
  //                       >
  //                         Send
  //                       </Button>
  //                     </Grid>
  //                   </Grid>
  //                 </CardContent>
  //               </Card>

  //               {/* Second Card */}
  //               <Card>
  //                 <CardContent>
  //                   <Typography mb={2}>User Details</Typography>
  //                   <TextField
  //                     label="Unique ID"
  //                     name="uniqueId1"
  //                     size="small"
  //                     value={formData1.uniqueId1}
  //                     onChange={handleChange1}
  //                     fullWidth
  //                   />
  //                   <Button
  //                     variant="contained"
  //                     sx={{ mt: 2 }}
  //                     fullWidth
  //                     onClick={handleOneSubmit}
  //                   >
  //                     Submit
  //                   </Button>
  //                 </CardContent>
  //               </Card>
  //             </Box>
  //           </Grid>

  //           {/* -------- RIGHT SIDE : MMTC -------- */}
  //           <Grid item xs={12} md={6}>
  //             <Box
  //               sx={{
  //                 boxShadow: 3,
  //                 borderRadius: 2,
  //                 p: 3,
  //                 backgroundColor: "#fff",
  //                 height: "100%",
  //               }}
  //             >
  //               <Typography variant="h6" fontWeight="bold" mb={2}>
  //                 MMTC KYC
  //               </Typography>

  //               {/* First Card */}
  //               <Card sx={{ mb: 3 }}>
  //                 <CardContent>
  //                   <TextField
  //                     label="Customer Ref No"
  //                     name="customerRefNo"
  //                     size="small"
  //                     value={formData.customerRefNo}
  //                     onChange={handleChange}
  //                     fullWidth
  //                   />
  //                   <Button
  //                     variant="contained"
  //                     sx={{ mt: 2 }}
  //                     fullWidth
  //                     onClick={handleValidate}
  //                   >
  //                     Send
  //                   </Button>
  //                 </CardContent>
  //               </Card>

  //               {/* Second Card */}
  //               <Card>
  //                 <CardContent>
  //                   <Typography mb={2}>User Details</Typography>
  //                   <TextField
  //                     label="Customer Ref No"
  //                     name="customerRefNo"
  //                     size="small"
  //                     value={formData1.customerRefNo}
  //                     onChange={handleChange1}
  //                     fullWidth
  //                   />
  //                   <Button
  //                     variant="contained"
  //                     sx={{ mt: 2 }}
  //                     fullWidth
  //                     onClick={handleOneSubmit}
  //                   >
  //                     Submit
  //                   </Button>
  //                 </CardContent>
  //               </Card>
  //             </Box>
  //           </Grid>
  //         </Grid>

  //         {/* User Table */}
  //         {userData && (
  //           <Box mt={3}>
  //             <UserDetailsTable data={userData} />
  //           </Box>
  //         )}
  //       </Box>
  //     ) : (
  //       <div>
  //         <Mfa
  //           setOtp={setOtp}
  //           otp={otp}
  //           handleSubmintOTP={handleSubmit}
  //           showOtp={openOtpModal}
  //           loading={loading}
  //           setOpenOtpModal={setOpenOtpModal}
  //         />
  //       </div>
  //     )}
  //   </>
  // );

  //-----------------closing without tab vala return-------------------------------
};

export default UpdateKyc;
